import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import Tol2008Select from "@/components/Tol2008Select.vue";
import ClassificationInformationsSelect from "@/components/ClassificationInformationsSelect.vue";
import ClassificationInformationsSelect2 from "@/components/ClassificationInformationsSelect2.vue";
import LanguageSelect from "@/components/LanguageSelect.vue";
import { useValidateProps } from "@/composables/fields";
import { dbEnums } from "@/types/enums/dbEnums";
import { CompanyDto } from "@api/company-dto";
import { PropType, computed, watch, ref, onMounted } from "vue";
import { CompanyFieldCategoryMap } from "..";
import Field from "../../Field.vue";
import FormFields from "../../FormFields.vue";
import FormSection from "../../FormSection.vue";
import FormSectionHeader from "../../FormSectionHeader.vue";
import type { CompanyFormDto } from "@api/company-form-dto";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyUpdateFormOtherFields',
  props: {
	fieldsMap: {
		type: Object as PropType<CompanyFieldCategoryMap>,
		required: true,
	},
	modelValue: {
		type: Object as PropType<CompanyDto>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const fields = dbEnums.CompanyFields;

const props = __props;

const emit = __emit;

const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const validateProps = useValidateProps();

const showAssociationDirectoryMenu = ref<boolean>(false);
const associationTypeCompanyForms = ref<string[]>([
	"Aatteellinen yhdistys",
	"Ulkomainen yhteisö",
	"Kotimainen yhteisö",
	"Yhdistys",
	"Kotimainen tai ulkomainen yhteisö",
	"Muu yhdistys",
]);

// onMounted(() => {
// 	if (formDataComputed.value.companyForm != null) {
// 		if (
// 			associationTypeCompanyForms.value.includes(
// 				formDataComputed.value.companyForm.technicalName
// 			)
// 		) {
// 			showAssociationDirectoryMenu.value = true;
// 		}
// 	}
// });

watch(
	() => formDataComputed.value.companyForm,
	(newVal: CompanyFormDto | null) => {
		showAssociationDirectoryMenu.value = false;
		if (newVal != null) {
			if (associationTypeCompanyForms.value.includes(newVal.technicalName)) {
				showAssociationDirectoryMenu.value = true;
			}
		}
	},
	{ deep: true, immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_HakoDatePicker = _resolveComponent("HakoDatePicker")!
  const _component_HakoTextArea = _resolveComponent("HakoTextArea")!
  const _directive_fieldMaxWidth = _resolveDirective("fieldMaxWidth")!

  return (_openBlock(), _createBlock(FormSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FormSectionHeader, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("companyForm.sectionOther.header")), 1)
            ]),
            _: 1
          })
        ]),
        (__props.fieldsMap.CompanyOtherInfo?.fields)
          ? (_openBlock(), _createBlock(FormFields, {
              key: 0,
              fields: __props.fieldsMap.CompanyOtherInfo.fields
            }, {
              [_unref(fields).EstablishedAt]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "establishedDate",
                  isUpdateForm: ""
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoDatePicker, {
                      modelValue: formDataComputed.value.establishedDate,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formDataComputed.value.establishedDate) = $event)),
                      allowEmpty: "",
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"250px"},
                      placeholder: _ctx.$t('generic.datePlaceholder'),
                      "force-utc-midnight": ""
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur", "placeholder"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).TurnoverClass]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "turnoverClassId",
                  isUpdateForm: ""
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid }) => [
                    _createVNode(ClassificationInformationsSelect2, {
                      valueSingle: formDataComputed.value.turnoverClass,
                      "onUpdate:valueSingle": _cache[1] || (_cache[1] = ($event: any) => ((formDataComputed.value.turnoverClass) = $event)),
                      valueSingleId: formDataComputed.value.turnoverClassId,
                      "onUpdate:valueSingleId": _cache[2] || (_cache[2] = ($event: any) => ((formDataComputed.value.turnoverClassId) = $event)),
                      infoTable: "TurnoverClasses",
                      translationsTable: "TurnoverClassTranslations",
                      translationProperty: "name",
                      ajax: false,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"250px"}
                    }, null, 8, ["valueSingle", "valueSingleId", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).StaffSizeClass]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "staffSizeClassId",
                  isUpdateForm: ""
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid }) => [
                    _createVNode(ClassificationInformationsSelect2, {
                      valueSingle: formDataComputed.value.staffSizeClass,
                      "onUpdate:valueSingle": _cache[3] || (_cache[3] = ($event: any) => ((formDataComputed.value.staffSizeClass) = $event)),
                      valueSingleId: formDataComputed.value.staffSizeClassId,
                      "onUpdate:valueSingleId": _cache[4] || (_cache[4] = ($event: any) => ((formDataComputed.value.staffSizeClassId) = $event)),
                      infoTable: "StaffSizeClasses",
                      translationsTable: "StaffSizeClassTranslations",
                      translationProperty: "name",
                      ajax: false,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"250px"}
                    }, null, 8, ["valueSingle", "valueSingleId", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).AdditionalInformation]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "additionalInformation",
                  isUpdateForm: ""
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.additionalInformation,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formDataComputed.value.additionalInformation) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).Description]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "description",
                  isUpdateForm: ""
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.description,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formDataComputed.value.description) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ProductsAndServices]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "productsAndServices",
                  isUpdateForm: ""
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.productsAndServices,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formDataComputed.value.productsAndServices) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).TOL2008]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "tol2008Id",
                  isUpdateForm: ""
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(Tol2008Select, {
                      id: elementId,
                      modelValue: formDataComputed.value.tol2008Id,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formDataComputed.value.tol2008Id) = $event)),
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["id", "modelValue", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).TerminatedAt]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "terminationDate",
                  isUpdateForm: ""
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoDatePicker, {
                      id: elementId,
                      modelValue: formDataComputed.value.terminationDate,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formDataComputed.value.terminationDate) = $event)),
                      allowEmpty: "",
                      "force-utc-midnight": "",
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"250px"}
                    }, null, 8, ["id", "modelValue", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ServiceDirectory]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  infoidentifier: "company.serviceDirectories",
                  isUpdateForm: ""
                }, {
                  default: _withCtx(({ isInvalid, propertyPaths }) => [
                    _withDirectives(_createVNode(ClassificationInformationsSelect2, {
                      valueMulti: formDataComputed.value.serviceDirectories,
                      "onUpdate:valueMulti": _cache[10] || (_cache[10] = ($event: any) => ((formDataComputed.value.serviceDirectories) = $event)),
                      infoTable: "ServiceDirectories",
                      translationsTable: "ServiceDirectoryTranslations",
                      translationProperty: "name",
                      ajax: false,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      tree: "",
                      noCascade: true,
                      disableTopLevelSelection: true,
                      style: {"max-width":"250px"}
                    }, null, 8, ["valueMulti", "isInvalid", "onBlur"]), [
                      [_directive_fieldMaxWidth, 'lg']
                    ])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).AssociationDirectory]: _withCtx(({ field }) => [
                _withDirectives(_createVNode(Field, {
                  field: field,
                  infoidentifier: "company.associationDirectories"
                }, {
                  default: _withCtx(({ isInvalid, propertyPaths }) => [
                    _withDirectives(_createVNode(ClassificationInformationsSelect2, {
                      valueMulti: formDataComputed.value.associationDirectories,
                      "onUpdate:valueMulti": _cache[11] || (_cache[11] = ($event: any) => ((formDataComputed.value.associationDirectories) = $event)),
                      infoTable: "AssociationDirectories",
                      translationsTable: "AssociationDirectoryTranslations",
                      translationProperty: "name",
                      ajax: false,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      tree: "",
                      noCascade: true,
                      style: {"max-width":"250px"}
                    }, null, 8, ["valueMulti", "isInvalid", "onBlur"]), [
                      [_directive_fieldMaxWidth, 'lg']
                    ])
                  ]),
                  _: 2
                }, 1032, ["field"]), [
                  [_vShow, showAssociationDirectoryMenu.value]
                ])
              ]),
              _: 2
            }, 1032, ["fields"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})